import React, { useEffect, useState } from "react";
import "./HealthStressesSurvey.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  updateSurveyData,
  updateSurveyPage,
} from "../../../../../redux/actions/survey";
import SurveyHero from "../../../../components/Survey/SurveyHero/SurveyHero";
import { Box } from "@mui/material";
import HealthConcernText from "../../../../components/Survey/HealthConcernText/HealthConcernText";
import getThemes from "../../../../../constants/colors/getTheme";
import Button from "../../../../components/Comon/Button/Button";
import LinkText from "../../../../components/Comon/LinkText/LinkText";

const HealthStressesSurvey = ({ showGlobalSnackbar, survey, i18n, app }) => {
  const [concerns, setConcerns] = useState([]);
  const [themeColor, setThemeColor] = useState([]);

  const navigate = useNavigate();
  const { code } = useParams();
  const dispatch = useDispatch();

  const getHealtConcernsForCurrentLanguage = () => {
    return survey?.settings?.clinic?.stresses.find(
        (item) => item.language.id === survey?.settings?.language?.id
    );
  };

  const initialConcerns = [
    {
      name: "physicalStresses",
      topText: getHealtConcernsForCurrentLanguage()?.physicalTitle,
      headline: getHealtConcernsForCurrentLanguage()?.physicalQuestion,
      text: "",
      options: [
        {
          id: 1,
          name: "sublaxation",
          text: getHealtConcernsForCurrentLanguage()?.physicalAnswer1,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[0]?.options[0].selected
              : false,
        },
        {
          id: 2,
          name: "sendetary",
          text: getHealtConcernsForCurrentLanguage()?.physicalAnswer2,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[0]?.options[1].selected
              : false,
        },
        {
          id: 3,
          name: "injuries",
          text: getHealtConcernsForCurrentLanguage()?.physicalAnswer3,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[0]?.options[2].selected
              : false,
        },
        {
          id: 4,
          name: "repetitiveStress",
          text: getHealtConcernsForCurrentLanguage()?.physicalAnswer4,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[0]?.options[3].selected
              : false,
        },
        {
          id: 5,
          name: "other",
          text:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[0]?.options[4].text
              : getHealtConcernsForCurrentLanguage()?.physicalAnswer5,
          isOther: true,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[0]?.options[4].selected
              : false,
        },
      ],
    },
    {
      name: "chemicalStress",
      topText: getHealtConcernsForCurrentLanguage()?.chemicalTitle,
      headline: getHealtConcernsForCurrentLanguage()?.chemicalQuestion,
      text: "",
      options: [
        {
          id: 1,
          name: "poorDiet",
          text: getHealtConcernsForCurrentLanguage()?.chemicalAnswer1,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[1]?.options[0].selected
              : false,
        },
        {
          id: 2,
          name: "notEnoughWater",
          text: getHealtConcernsForCurrentLanguage()?.chemicalAnswer2,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[1]?.options[1].selected
              : false,
        },
        {
          id: 3,
          name: "drugs",
          text: getHealtConcernsForCurrentLanguage()?.chemicalAnswer3,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[1]?.options[2].selected
              : false,
        },
        {
          id: 4,
          name: "chemicalOverload",
          text: getHealtConcernsForCurrentLanguage()?.chemicalAnswer4,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[1]?.options[3].selected
              : false,
        },
        {
          id: 5,
          name: "other",
          text:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[1]?.options[4].text
              : getHealtConcernsForCurrentLanguage()?.chemicalAnswer5,
          isOther: true,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[1]?.options[4].selected
              : false,
        },
      ],
    },
    {
      name: "mentalStress",
      topText: getHealtConcernsForCurrentLanguage()?.emotionalTitle,
      headline: getHealtConcernsForCurrentLanguage()?.emotionalQuestion,
      text: "",
      options: [
        {
          id: 1,
          name: "negativeThinking",
          text: getHealtConcernsForCurrentLanguage()?.emotionalAnswer1,
          order: 1,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[2]?.options[0].selected
              : false,
        },
        {
          id: 3,
          name: "homeStress",
          text: getHealtConcernsForCurrentLanguage()?.emotionalAnswer3,
          order: 2,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[2]?.options[1].selected
              : false,
        },
        {
          id: 4,
          name: "stressRelationship",
          order: 3,
          text: getHealtConcernsForCurrentLanguage()?.emotionalAnswer4,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[2]?.options[2].selected
              : false,
        },
        {
          id: 5,
          name: "other",
          order: 4,
          text:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[2]?.options[3].text
              : getHealtConcernsForCurrentLanguage()?.emotionalAnswer5,
          isOther: true,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[2]?.options[3].selected
              : false,
        },
        {
          id: 2,
          order: 5,
          name: "anxiety",
          text: getHealtConcernsForCurrentLanguage()?.emotionalAnswer2,
          selected:
            survey.data && survey.data.healthStresses
              ? survey.data.healthStresses[2]?.options[5]?.selected
              : false,
        },
      ],
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(updateSurveyPage(2));
  }, []);

  useEffect(() => {
    setConcerns(initialConcerns);

    if (survey.data == null) {
      survey.data = { healthStresses: initialConcerns };
    } else {
      survey.data.healthStresses = initialConcerns;
    }
    dispatch(updateSurveyData(survey.data));
  }, []);

  useEffect(() => {
    setThemeColor(getThemes("mainColor", app.appTheme));
  }, [app]);

  const nextPage = () => {
    dispatch(updateSurveyPage(3));
    navigate("/survey/" + code + "/health-concerns");
  };

  const previousPage = () => {
    dispatch(updateSurveyPage(1));
    navigate("/survey/" + code + "/patient-profile");
  };

  const updateConcern = (data, index) => {
    concerns[index].options = data;

    setConcerns([...concerns]);

    if (survey.data == null) {
      survey.data = { healthStresses: concerns };
    } else {
      survey.data.healthStresses = concerns;
    }
    dispatch(updateSurveyData(survey.data));
  };

  const scrollTo = () => {
    const element = document.getElementById(concerns[0].name);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  return (
    <div className="ThirdScreenSurvey">
      <SurveyHero
        // step={i18n.t("step") + " 2"}
        headline={survey?.settings?.stressesHeadline}
        text={survey?.settings?.stressesText}
        videoLink={survey?.settings?.stressesVideo}
        buttonText={i18n.t("next")}
        clickedButton={() => scrollTo()}
        app={app}
        surveyType={survey?.settings?.type}
      />

      <div className={"concernsContainer"}>
        {concerns.map((concern, index) => {
          return (
            <div className={"concernContainer"} key={index}>
              <HealthConcernText
                setConcernText={(value) => updateConcern(index, value, "text")}
                setConcernRate={(value) => updateConcern(index, value, "rate")}
                mandatory={concern.mandatory}
                text={concern.text}
                concernRate={concern.concernRate}
                topText={concern.topText}
                headline={concern.headline}
                themeColor={themeColor}
                hasTextInput={false}
                leftOption={i18n.t("notSevere")}
                rightOption={i18n.t("severe")}
                i18n={i18n}
                id={concern.name}
                options={concern.options}
                setOptions={(data) => updateConcern(data, index)}
                concernText={concern.concern}
              />
            </div>
          );
        })}
      </div>
      <div className={"buttonsContainer"}>
        <div className={"nextContainer"} onClick={() => nextPage()}>
          <Button color={themeColor} mode={"small"} text={i18n.t("next")} />
        </div>
        <div className={"previousContainer"} onClick={() => previousPage()}>
          <LinkText text={i18n.t("previous")} />
        </div>
      </div>
    </div>
  );
};

export default HealthStressesSurvey;
